export default __webpack_public_path__ + "static/shop-ce457f423e7651f7e9cc7978e776438e.svg";